
































































































































































import { Component, Mixins } from 'vue-property-decorator';
import { mapGetters, mapActions } from 'vuex';
import { getState } from '@/storage';
import { Actions, Mutations, Views, Buttons, GlobalOverlays } from '@/ts/store/Constants';
import ImageCapture from '@/components/Media/ImageCapture.vue';
import ImageCropper from '@/components/Media/ImageCropper.vue';
import Feedback from '@/components/User/Feedback.vue';
import AddParticipantButton from '@/components/HeaderButtons/AddParticipantButton.vue';
import BackButton from '@/components/HeaderButtons/BackButton.vue';
import HococoAddButton from '@/components/HeaderButtons/HococoAddButton.vue';
import HandButton from '@/components/HeaderButtons/HandButton.vue';
import HococoButton from '@/components/HeaderButtons/HococoButton.vue';
import EventListButton from '@/components/HeaderButtons/EventListButton.vue';
import EventCalendarButton from '@/components/HeaderButtons/EventCalendarButton.vue';
import HococoEditButton from '@/components/HeaderButtons/HococoEditButton.vue';
import HococoDownloadButton from '@/components/HeaderButtons/HococoDownloadButton.vue';
import UserProfileButton from '@/components/HeaderButtons/UserProfileButton.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import DeviceMethods from '@/mixins/DeviceMethods.vue';
import UserMethods from '@/mixins/UserMethods.vue';
import FullScreenImageViewer from '@/components/Media/FullScreenImageViewer.vue';
import PrivacyPolicyScreen from '@/components/Dialogs/PrivacyPolicyScreen.vue';
import ChangePassword from '@/components/User/ChangePassword.vue';
import Pin from '@/components/User/Pin.vue';
import SetPin from '@/components/User/SetPin.vue';
import ContactUs from '@/components/Admin/Panels/ContactUs.vue';
import TopBar from '@/components/TopBar.vue';
import MobileFooter from '@/components/Layout/MobileFooter.vue';
import MobileAside from '@/components/Layout/MobileAside.vue';
import MobileHeader from '@/components/Layout/MobileHeader.vue';
import ContentDialog from '@/components/Dialogs/ContentDialog.vue';
import { Connection } from '@/configuration/Connection';
import AddNewTicketAnswer from '@/components/User/Panels/AddNewTicketAnswer.vue';
import AddNewTicketThanks from '@/components/User/Panels/AddNewTicketThanks.vue';
import Aside from '@/components/Admin/Layout/Aside.vue';
import IdentitiesAside from '@/components/Admin/Layout/IdentitiesAside.vue';
import HomeAssistant from '@/components/Overlays/HomeAssistant.vue';
import ReportIssue from '@/components/Overlays/TicketSystem/ReportIssue.vue';
import ImageViewer from '@/components/Media/ImageViewer.vue';
import CurvedModal from '@/components/Modal/CurvedModal.vue';
import OrderPay from '@/components/User/Wallet/OrderPay.vue';
import OrderSuccessModalContent from '@/components/User/Wallet/OrderSuccessModalContent.vue';
import OrderFailureModalContent from '@/components/User/Wallet/OrderFailureModalContent.vue';
import CommentsOverlayMobile from '@/components/Overlays/CommentsOverlayMobile.vue';
import FullScreenLoader from '@/components/Loaders/FullScreenLoader.vue';
import SwitchAccount from '@/components/Overlays/Actions/SwitchAccount.vue';
import GlobalOverlay from '@/components/Globals/Overlay/GlobalOverlay.vue';
import ErrorHelper from './mixins/ErrorHelper.vue';
import AddCreditCardOverlay from '@/components/User/Wallet/AddCreditCardOverlay.vue';

import { PushNotifications } from '@capacitor/push-notifications';
import { SplashScreen } from '@capacitor/splash-screen';
import { App as CapacitorApp, AppState } from '@capacitor/app';
import Modal from '@/components/Modal/Modal.vue';

@Component({
    methods: {
        ...mapActions({
            logOut: Actions.LOG_OUT,
        }),
    },
    computed: {
        ...mapGetters({
            userIsLoggedIn: 'User/userIsLoggedIn',
            cameraDialogVisible: 'Camera/cameraDialogVisible',
            imageCropperVisible: 'Images/imageCropperVisible',
            feedbackDialogVisible: 'Feedback/feedbackDialogVisible',
            termsVisible: 'Viewport/termsVisible',
            changePasswordDialogVisible: 'Viewport/changePasswordVisible',
            setPinDialogVisible: 'Viewport/setPinVisible',
            contactUsVisible: 'UserManagement/getContactUsVisible',
            keywordOpenedForJanitor: 'StaffProperties/getIndexPagesKeyboardVisibility',
            closeButtonVisibility: 'Viewport/getBottomNavigationCloseButton',
            globalOverlayVisibility: 'Viewport/getGlobalOverlayVisibility',
            globalOverlayComponent: 'Viewport/getGlobalOverlayComponent',
            globalOverlayWasOpenedLocally: 'Viewport/getGlobalOverlayWasOpenedLocally',
            addNewTicketAnswerVisibility: 'UserTickets/getAddNewTicketAnswerVisibility',
            addNewTicketThanksVisibility: 'UserTickets/getAddNewTicketThanksVisibility',
            homeAssistantOverlayVisibility: 'HomeAssistant/getHomeAssistantVisibility',
            issueReportOverlayVisibility: 'IssueReport/getReportIssueOverlayVisibility',
            imageViewerVisible: 'Images/imageViewerVisible',
            getCommentsOverlayVisibility: 'Comments/getCommentsOverlayVisibility',
            loadingStatus: 'Loading/getLoadingStatus',
            accountSwitcherVisibility: 'Overlays/getAccountSwitcherVisibility',
        }),
    },
    components: {
        OrderSuccessModalContent,
        OrderFailureModalContent,
        OrderPay,
        CurvedModal,
        ImageCapture,
        ImageCropper,
        Feedback,
        HococoButton,
        AddParticipantButton,
        BackButton,
        HococoAddButton,
        EventListButton,
        EventCalendarButton,
        HococoEditButton,
        HococoDownloadButton,
        UserProfileButton,
        FullScreenImageViewer,
        ErrorMessage,
        PrivacyPolicyScreen,
        ChangePassword,
        Pin,
        SetPin,
        ContactUs,
        TopBar,
        MobileFooter,
        MobileAside,
        MobileHeader,
        ContentDialog,
        HandButton,
        AddNewTicketAnswer,
        AddNewTicketThanks,
        Aside,
        IdentitiesAside,
        HomeAssistant,
        ReportIssue,
        ImageViewer,
        CommentsOverlayMobile,
        FullScreenLoader,
        SwitchAccount,
        GlobalOverlay,
        Modal,
        AddCreditCardOverlay
    },
})

export default class App extends Mixins(DeviceMethods, UserMethods, ErrorHelper) {
    public isReady: boolean = false;

    constructor() {
        super();

        this.isReady = true;

        // Initialize convenient globals
        window.hoc = {
            userRoleMap: {},
            userRoleKeys: {},
        };

        this.device().then((deviceInfo) => {
            this.$store.commit(Mutations.SET_DEVICE_INFO, deviceInfo);

            if (deviceInfo.platform === 'ios' || deviceInfo.platform === 'android') {
                PushNotifications.requestPermissions();

                // const { Filesystem } = Plugins;

                //     Filesystem.mkdir({
                //         path: 'hococo',
                //         directory: FilesystemDirectory.Documents,
                //         createIntermediateDirectories: true,
                //     }).then(() => {
                //         Filesystem.writeFile({
                //             path: 'hococo/hococo.txt',
                //             data: 'This folder stores documents from the Hococo app.',
                //             directory: FilesystemDirectory.Data,
                //             encoding: FilesystemEncoding.UTF8,
                //         }).catch((exception) => {
                //             console.log('Could not write file', exception);
                //         });
                //     }).catch((exception) => {
                //         console.error('Unable to make directory', exception);
                //     });
                // this.requestCalendarAccess(deviceInfo.platform);
            }

            this.initializeStateChangeListeners();
        });

        SplashScreen.hide().catch(() => {/* Do nothing on web. */});

        if (Connection.socketEnabled) {
            // Register socket listeners
            this.$echo.connector.socket.on('connect', () => {
                this.$store.commit(Mutations.SET_SOCKET_STATUS, {
                    status: true,
                    vue: this,
                });
            });

            this.$echo.connector.socket.on('disconnect', () => {
                this.$store.commit(Mutations.SET_SOCKET_STATUS, {
                    status: false,
                    vue: this,
                });
            });
        }
    }

    public closePriorityDropDown() {
        this.$store.commit(Mutations.TICKET_PRIORITY_DROPDOWN_VISIBILITY, false);
    }

    public closeCurvedModal() {
        this.$store.commit(Mutations.SET_PAY_FOR_ORDER_MODAL_VISIBILITY, false);
        this.$store.commit(Mutations.SET_ORDER_PAY_SUCCESS_MODAL_VISIBILITY, false);
    }
    
    get globalOverlayRequireAnimation(): boolean {
        return this.$store.getters['Viewport/getGlobalOverlayComponent'] === GlobalOverlays.TICKET_TYPE;
    }

    get termsVisible() {
        return this.$store.getters['Viewport/termsVisible'];
    }

    get contentOverlayCloseAction() {
        return Mutations.SET_GLOBAL_OVERLAY_VISIBILITY;
    }

    get isStaff() {
        return this.$store.getters['User/getUser']
            ? !this.$store.getters['User/getUser'].isTenant
            : false;
    }

    private requestCalendarAccess(deviceType: string) {
        const calendar = (window as any).plugins.calendar;

        this.$store.commit(Mutations.REQUESTED_CALENDAR_ACCESS);
        calendar.hasReadWritePermission(
            (hasPermission: any) => {
                if (hasPermission === false) {
                    calendar.requestReadWritePermission(
                        (success: any) => {
                            this.$store.commit(Mutations.ACCEPT_CALENDAR_ACCESS);
                        },
                        (failure: any) => {
                            console.log(failure);
                        },
                    );
                } else {
                    this.$store.commit(Mutations.ACCEPT_CALENDAR_ACCESS);
                }

                calendar.listCalendars(
                    (result: any) => {
                        this.$store.commit(Mutations.SET_DEVICE_CALENDARS, result);

                        for (const calendarInstance of result) {
                            if ((deviceType === 'android' && calendarInstance.isPrimary)
                            || (deviceType === 'ios' && calendarInstance.type === 'CalDAV')) {
                                this.$store.commit(Mutations.SET_DEVICE_CALENDAR_NAME, calendarInstance.name);
                                break;
                            }
                        }
                    },
                    (failure: any) => {
                        console.log(failure);
                    },
                );
        });
    }

    private initializeStateChangeListeners() {
        // tslint:disable-next-line
        CapacitorApp.addListener('appStateChange', (state: AppState) => {
            if (state.isActive === true && this.$store.getters['User/userIsLoggedIn']) {
                this.$store.dispatch(Actions.FETCH_CONVERSATIONS, {
                    vue: this,
                    forceUpdate: true,
                });
            }
        });
    }

    private async loadCache() {
        if (this.$store.state.initialized) {
            return Promise.resolve(null);
        }

        this.$store.commit('loadFromCache', await getState());

        if (Connection.socketEnabled && this.$store.state.User.authData) {
            this.$echo.connector.options.auth.headers.Authorization =
                'Bearer ' + this.$store.state.User.authData.accessToken;

            this.$echo.connector.options.auth.headers['Hococo-Context']   = this.$store.state.Identities.selectedIdentity.context;
            this.$echo.connector.options.auth.headers['Hococo-User-Type'] = this.$store.state.Identities.selectedIdentity.userType;
        }
    }

    get addCreditCardFormVisibility(): boolean {
        return this.$store.getters['CreditCards/getAddNewCardFormVisibility'];
    }

    get isFullScreen() {
        return this.$store.getters['Images/getIsFullscreen'];
    }

    get isSearching() {
        return this.$store.getters['vuexSearch/@@vuexSearch/getter/isSearching']('messages');
    }

    get searchResults() {
        return this.$store.getters['vuexSearch/@@vuexSearch/getter/result']('messages');
    }

    get messageSearchTerms(): string {
        return this.$store.getters['Messages/getConversationSearchTerm'];
    }

    get headerText() {
        return this.$store.getters['Viewport/headerText'];
    }

    get shelfClasses() {
        return {
            'hococo-shelf-visible': this.shelfVisible,
        };
    }

    get transparentHeader() {
        return this.$store.getters['Viewport/hasTransparentHeader'];
    }

    get animateTransparentHeader() {
        return this.$store.getters['Viewport/shouldAnimateHeaderTransition'];
    }

    get unreadMessageCountString(): string {
        const messageCount = this.$store.getters['Messages/unreadMessageCount'];

        if (!messageCount || messageCount === 0) {
            return '';
        }

        return ' (' + messageCount + ')';
    }

    get errorDialogVisible() {
        return this.$store.getters['Viewport/errorDialogVisible'] && this.showErrorDialog(this.$store.getters['Viewport/currentErrorMessage']);
    }

    get documentLoading() {
        return this.$store.getters['Viewport/documentLoading'];
    }

    get showPayForOrderModal() {
        return this.$store.getters['UserWallet/getPayForOrderModalVisibility'];
    }

    get showOrderPaySuccessModal() {
        return this.$store.getters['UserWallet/getOrderPaySuccessModalVisibility'];
    }
    
    get showOrderPayFailureModal() {
        return this.$store.getters['UserWallet/getOrderPayFailureModalVisibility'];
    }

    // private mobileLogOut() {
    //     this.hideShelfMenu();
    //     this.$store.dispatch(Actions.LOG_OUT);
    // }

    private showShelfMenu() {
        this.$store.dispatch(Actions.SHOW_SHELF);
    }

    private hideShelfMenu() {
        this.$store.dispatch(Actions.HIDE_SHELF);
    }

    private async created() {
        await this.loadCache();
        await this.$store.dispatch(Actions.GET_USER_LANGUAGE_CODE);
        
        const { User: { selectedLanguage: language } } = this.$store.state;

        if (language) {
            this.$store.dispatch(Actions.SET_LANGUAGE, {language , vue: this});
        }
        
        if (this.$store.state.setUserData === true && this.$route.name !== 'login') {
            this.$store.dispatch(Actions.REFRESH_USER_DATA, this);
        }

        window.dispatchEvent(new Event('resize'));
        window.addEventListener('click', this.closePriorityDropDown);
    }

    private beforeCreate() {
        this.$store.commit(Mutations.SET_VIEW, Views.Home);
        this.$store.commit(Mutations.SET_LEFT_HEADER_BUTTON, Buttons.None);
        this.$store.dispatch(Actions.INITIALIZE_VIEWPORT);
    }

    // TO BE USED WITH THE NEW LAYOUT UNTIL NEW SYSTEM IS IMPLEMENTED
    get showMobileHeader() {
        return !['user-channel-list', 'user-channel'].includes(this.$route.name);
    }
}
